<!------------------------------------------------------------------------------
 File: BaseSwitch 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 2019-03-07
 Time: 14:31
------------------------------------------------------------------------------->
<template>
    <div class="no-gutters" :class="{
    'row':row
    }">
        <div v-if="typeof label !== 'undefined' && label !== null"
             class="col-sm-12 col-md-4 text-sentence"
        >{{label}}
        </div>
        <div :class="{
                    'col-sm-12 col-md-8':typeof label !== 'undefined' && label !== null && row,
                    'col':typeof label == 'undefined' && row || label == null && row
                }">
            <div class="switch">
                <label
                        v-tooltips-enabled="{
                        active:tooltip,
                        title:title
                    }"
                >
                    <span class="text-sentence">{{switch_off}}</span>
                    <input :tabindex="tabindex"
                           type="checkbox"
                           :checked="checked"
                           :name="field"
                           v-model="input_value">
                    <span class="lever"></span>
                    <span class="text-sentence">{{switch_on}}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import vueTooltip from './tooltip/vueTooltip';

    Vue.use(vueTooltip);

    export default {
        name: "BaseSwitch",
        components: {},
        props: {
            tabindex: {
                type: Number
            },
            cls: {
                type: String
            },
            row: {
                type: Boolean,
                default: true
            },
            label: {
                type: String,
                default:null
            },
            field: {
                type: String,
                default: 'status'
            },
            checked: {
                type: Boolean,
                default: false            
            },
            switch_off: {
                type: String,
                default: 'off'
            },
            switch_on: {
                type: String,
                default: 'on'
            },
            title: {
                type: String,
                default: null
            },
            tooltip: {
                type: Boolean,
                default: true
            }
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
        },
        data() {
            return {
                input_value: this.checked
            }
        },
        methods: {},
        watch: {
            input_value: function () {
                this.$emit('input_value', this.input_value)
            }
        },
        computed: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseSwitch.vue?7bdf0df8